// Every new intent or scene invalidates work started by an older intent.
export function createRequestEpoch() {
  let epoch = 0;
  return {
    begin: () => ++epoch,
    invalidate: () => { epoch += 1; },
    isCurrent: (candidate: number) => candidate === epoch
  };
}
